import { useState, useCallback } from "react";

export const useNotesAndTerms = (initialValue: string = "") => {
  const [notes, setNotes] = useState<string>(initialValue);

  const updateNotes = useCallback((value: string) => {
    setNotes(value);
  }, []);

  return {
    notes,
    updateNotes,
  };
};
